// Angular-Module
import {Injectable} from '@angular/core';
// ReactiveX for JavaScript
import {Observable} from 'rxjs';
// Globale Services
import {AppCoreService} from '@global/services/app-core.service';
import {BackendService} from '@global/services/backend.service';
// Interfaces für Structured Objects einbinden
import {CWEvent} from '@shared/cw-event';

@Injectable({providedIn: 'root'})
export class EventsBudgetAllocationDataService {
    /**
     * Konstruktor
     * @param appCore
     * @param backendService
     */
    constructor(
        private appCore: AppCoreService,
        private backendService: BackendService,
    ) {}

    /**
     * @brief   Detaildaten einer Budgetzuordnung laden
     * @details Prototyp für Demo
     * @param   id  number      Bei der übergebenen ID handelt es sich um
     *                          die Region-ID des AD-Mitarbeiters, für welchen
     *                          Budgets vergeben werden sollen.
     * @returns  Observable<any>
     */
    loadData(id: number): Observable<any> {
        // GET-Request über BackendService senden
        const getRequest$: Observable<any> = this.backendService.getRequest('EventsBudgetAllocationData/details/' + id);
        // Observable (an Komponente) zurücklieferen
        return getRequest$;
    }

    /**
     * @brief   Speichert Detaildaten einer Budgetzuordnung
     * @param formData
     * @details Prototyp für Demo
     * @param   id  number
     */
    saveData(formData: any): Observable<any> {
        // POST-Request über BackendService senden
        const postRequest$: Observable<any> = this.backendService.postRequest(
            'EventsBudgetAllocationData/edit',
            formData,
        );
        // Observable (an Komponente) zurücklieferen
        return postRequest$;
    }

    /**
     * @param data
     * @brief      Falls Daten erfolgreich geändert wurden
     * @details    Sendet aktualisierten Datensatz per Event, damit andere
     *             Module (z.B. Listen) darauf reagieren können
     */
    dataChanged(data: any): void {
        // Informationen für Event
        const eventData: CWEvent = {
            sender: 'events-budget-allocation-data',
            target: '',
            data: {changedItem: data},
        };
        // Event auslösen
        this.appCore.appDataChanged.next(eventData);
    }

    /**
     * @brief   Löscht eine Budgetzuordnung
     * @param   id  number  ID der zu löschenden Budgetzuordnung
     * @returns Observable<any>
     */
    deleteData(id: number): Observable<any> {
        // GET-Request über BackendService senden
        const getRequest$: Observable<any> = this.backendService.getRequest('EventsBudgetAllocationData/delete/' + id);
        // Observable (an Komponente) zurücklieferen
        return getRequest$;
    }

    loadBudgetRegions(): Observable<any> {
        // GET-Request über BackendService senden
        const getRequest$: Observable<any> = this.backendService.getRequest(
            'EventsBudgetAllocationData/getBudgetRegions/',
        );
        // Observable (an Komponente) zurücklieferen
        return getRequest$;
    }

    /**
     * @brief   Liefert alle Gebiete, für die im relevanten Geschäftsjahr tatsächlich ein
     *          Budget existiert.
     * @details Anders als loadBudgetRegions() (ausnahmslos alle Gebiete) hier schon
     *          eingeschränkt auf jene mit echtem Budget - siehe SD-3482.
     */
    getBudgetRegionCandidates(eventStart?: string): Observable<any> {
        const query = eventStart ? ('?event_start=' + encodeURIComponent(eventStart)) : '';
        const getRequest$: Observable<any> = this.backendService.getRequest(
            'EventsData/getBudgetRegionCandidates/' + query,
        );
        return getRequest$;
    }
}
